import React from 'react'
import { Button, Container } from '@sencha/ext-modern'
import { getMixedProps } from '../blockPublic'
import { reconfigButton } from 'tyan/public/utility'

const Buttons = ({ docked, buttons }) => <Container
	layout={['top', 'bottom'].includes(docked) ? { type: 'hbox', pack: 'end' } : { type: 'vbox', pack: 'center' }}
	margin="0px 0px 0px 0px" flex={1}/* width="100%" */>
	{buttons.map((o1, i) => {
		const o = reconfigButton(o1)
		const { props: btnProps } = getMixedProps('_button', [o])
		o.disabled && typeof o.disabled === 'function' && (btnProps.disabled = o.disabled())
		o.icon != undefined && (typeof o.icon === 'function' ? (btnProps.iconCls = `x-fa fa-${o.icon()}`) : btnProps.iconCls = `x-fa fa-${o.icon}`)
		btnProps.margin = o1.margin || '0px 0px 0px 20px'
		return o.cdt && !o.cdt() ? null : <Button key={i} text={o._button} {...btnProps} />
	})}
</Container>

export default Buttons